import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      candidateDisplayPicture:
        'candidateProfilePicture/candidateDisplayPicture',
    }),
    $_candidateProfileImageMixin_profilePicture() {
      const picture = this.candidateDisplayPicture(this.id)
      return picture ? `data:image/jpeg;base64,${picture}` : null
    },
  },
  data() {
    return {
      $_candidateProfileImageMixin_shouldLoad: false,
      $_candidateProfileImageMixin_observer: null,
    }
  },
  mounted() {
    // Use Intersection Observer for lazy loading
    if ('IntersectionObserver' in window) {
      this.$_candidateProfileImageMixin_observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.$_candidateProfileImageMixin_shouldLoad = true
              // Disconnect immediately after triggering
              if (this.$_candidateProfileImageMixin_observer) {
                this.$_candidateProfileImageMixin_observer.disconnect()
                this.$_candidateProfileImageMixin_observer = null
              }
            }
          })
        },
        { rootMargin: '50px' } // Start loading 50px before visible
      )
      this.$_candidateProfileImageMixin_observer.observe(this.$el)
    } else {
      // Fallback for browsers without IntersectionObserver
      this.$_candidateProfileImageMixin_shouldLoad = true
    }
  },
  watch: {
    $_candidateProfileImageMixin_shouldLoad(newVal) {
      if (newVal && this.id != null) {
        this.$_candidateProfileImageMixin_loadCandidateDisplayPicture(this.id)
      }
    },
  },
  beforeDestroy() {
    // Cleanup: Cancel the request and disconnect observer
    if (this.id != null) {
      this.$_candidateProfileImageMixin_cancelDisplayPictureRequest(this.id)
    }

    // Disconnect Intersection Observer
    if (this.$_candidateProfileImageMixin_observer) {
      this.$_candidateProfileImageMixin_observer.disconnect()
      this.$_candidateProfileImageMixin_observer = null
    }
  },
  methods: {
    ...mapActions({
      $_candidateProfileImageMixin_loadCandidateDisplayPicture:
        'candidateProfilePicture/loadCandidateDisplayPicture',
      $_candidateProfileImageMixin_cancelDisplayPictureRequest:
        'candidateProfilePicture/cancelDisplayPictureRequest',
    }),
  },
}
